import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const EmailIcon = ({size = SIZE.STANDARD, color = '#535353', onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.STANDARD:
				return '12';
			default:
				return '12';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.STANDARD:
				return '10';
			default:
				return '10';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width={getWidth(size)} height={getHeight(size)} viewBox="0 0 16 12" fill="none">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1.5 2.68433V10C1.5 10.1137 1.60297 10.25 1.78539 10.25H14.2101C14.3925 10.25 14.4955 10.1137 14.4955 10V2.68431L9.83726 6.14472L9.83721 6.14475C9.30696 6.53871 8.66021 6.75007 7.99771 6.75007C7.33521 6.75007 6.68846 6.53871 6.15821 6.14475L6.15817 6.14472L1.5 2.68433ZM13.2378 1.75H2.75766L7.0527 4.94064L7.05275 4.94068C7.32082 5.13985 7.65301 5.25007 7.99771 5.25007C8.34241 5.25007 8.6746 5.13985 8.94267 4.94068L8.94272 4.94064L13.2378 1.75ZM1.78539 0.25C0.824145 0.25 0 1.00913 0 2V10C0 10.9909 0.824145 11.75 1.78539 11.75H14.2101C15.1713 11.75 15.9955 10.9909 15.9955 10V2C15.9955 1.00913 15.1713 0.25 14.2101 0.25H1.78539Z"
					fill={color}
				/>
			</svg>
		</StyledSpan>
	);
};

EmailIcon.SIZE = SIZE;
EmailIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

export const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
